var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('catalog-category', {
    ref: "child",
    attrs: {
      "category": _vm.$route.query['header'] || 'all',
      "selected-id": _vm.selectedId,
      "hide-header": !_vm.$route.query['header'],
      "hide-background": !_vm.$route.query['header']
    },
    on: {
      "update-router-view-meta": function (v) {
        return _vm.routerViewMeta = v;
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }